import { render, staticRenderFns } from "./FileImportWaste.vue?vue&type=template&id=707d29c3&scoped=true&"
import script from "./FileImportWaste.vue?vue&type=script&lang=js&"
export * from "./FileImportWaste.vue?vue&type=script&lang=js&"
import style0 from "./FileImportWaste.vue?vue&type=style&index=0&id=707d29c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d29c3",
  null
  
)

export default component.exports